import React, { useState } from "react";
import {
  Message,
  TextArea,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk, errorMessage } from "../../lib/index";
import { useEthnicGroupContext } from "../../context/EthnicGroupContext";
import { getOneEthnicGroup } from "../../lib/sysNavigation/SysNavigation";
import { HiOutlineUserGroup } from "react-icons/hi";

const Edit = () => {
  const { updateEthnicGroupState, updateEthnicGroup } = useEthnicGroupContext();
  const ethnicGroup = getOneEthnicGroup();

  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const ethnic_group_id = ethnicGroup.ethnic_group_id;
  const [name, setName] = useState(ethnicGroup.name);
  const [description, setDescription] = useState(ethnicGroup.description);

  const ethnicGroupRoutes = "/ethnic/group";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError: any, _status: any, _message: any) => {
    setError(isError);
    setStatus(_status);
    setErrorMessage(_message);
  };

  const updateOneEthnicGroupHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = { name, description };
    const response = await updateEthnicGroup(ethnic_group_id, data);

    if (response) {
      if (response.data.status === codeOk) {
        updateEthnicGroupState({ ethnic_group_id, ...data });
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={ethnicGroupRoutes}
      eyebrow="Catalog • Ethnic Groups"
      title="Edit Ethnic Group"
      subtitle="Updated cultural identity that helps localise content for travellers."
      icon={<HiOutlineUserGroup className="h-5 w-5" />}
      size="md"
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneEthnicGroupHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <Message
          props={{
            error,
            success,
            message,
            loading,
            status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />
      }
    >
      <AddSection
        title="Ethnic Group Details"
        hint="Provide the recognised name and a brief description."
      >
        <div className="grid grid-cols-1 gap-4">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              required: true,
              value: name ? name : "",
              onChange: (e: any) => {
                setName(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <TextArea
            props={{
              id: "description",
              title: "Description",
              type: "text",
              required: true,
              value: description ? description : "",
              onChange: (e: any) => {
                setDescription(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
